const positiveNumberOrNull = value => {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(String(value).replace(',', '.'));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

const numberOrNull = value => {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
};

const cleanArray = values =>
  (Array.isArray(values) ? values : [])
    .map(value => (typeof value === 'string' ? value.trim() : value))
    .filter(Boolean);

export const createListingForm = listing => {
  const source = listing || {};
  const address = source.address || {};
  const pricing = source.pricing || source.pricing_infos?.[0] || {};

  return {
    canalproAccountId:
      source.canalpro_account_id || source.canalproAccountId || '',
    title: source.title || '',
    description: source.description || '',
    businessType: source.business_type || source.businessType || 'SALE',
    propertyType: source.property_type || source.propertyType || 'APARTMENT',
    publicationType:
      source.publication_type || source.publicationType || 'STANDARD',
    price: pricing.price ?? source.price ?? '',
    monthlyCondoFee:
      pricing.monthly_condo_fee ??
      pricing.monthlyCondoFee ??
      source.condo_fee ??
      '',
    yearlyIptu: pricing.yearly_iptu ?? pricing.yearlyIptu ?? source.iptu ?? '',
    showPrice: source.show_price ?? source.showPrice ?? true,
    displayAddress: source.display_address ?? source.displayAddress ?? true,
    state: address.state || source.state || '',
    city: address.city || source.city || '',
    neighborhood: address.neighborhood || source.neighborhood || '',
    street: address.street || source.street || '',
    streetNumber:
      address.street_number ||
      address.streetNumber ||
      source.street_number ||
      '',
    complement: address.complement || source.complement || '',
    zipCode: address.zip_code || address.zipCode || source.zip_code || '',
    bedrooms: source.bedrooms ?? '',
    bathrooms: source.bathrooms ?? '',
    suites: source.suites ?? '',
    parkingSpaces: source.parking_spaces ?? source.parkingSpaces ?? '',
    usableArea: source.usable_area ?? source.usableAreas ?? '',
    totalArea: source.total_area ?? source.totalAreas ?? '',
    amenities: cleanArray(source.amenities),
    images: cleanArray(source.images || source.media),
  };
};

export const listingPayloadFromForm = form => ({
  canalpro_account_id: form.canalproAccountId,
  title: form.title.trim(),
  description: form.description.trim(),
  business_type: form.businessType,
  property_type: form.propertyType,
  publication_type: form.publicationType,
  show_price: Boolean(form.showPrice),
  display_address: Boolean(form.displayAddress),
  bedrooms: numberOrNull(form.bedrooms),
  bathrooms: numberOrNull(form.bathrooms),
  suites: numberOrNull(form.suites),
  parking_spaces: numberOrNull(form.parkingSpaces),
  usable_area: positiveNumberOrNull(form.usableArea),
  total_area: positiveNumberOrNull(form.totalArea),
  amenities: cleanArray(form.amenities),
  address: {
    state: form.state.trim(),
    city: form.city.trim(),
    neighborhood: form.neighborhood.trim(),
    street: form.street.trim(),
    street_number: form.streetNumber.trim(),
    complement: form.complement.trim(),
    zip_code: form.zipCode.trim(),
  },
  pricing: {
    price: positiveNumberOrNull(form.price),
    monthly_condo_fee: positiveNumberOrNull(form.monthlyCondoFee),
    yearly_iptu: positiveNumberOrNull(form.yearlyIptu),
  },
  media_ids: cleanArray(form.images)
    .filter(image => !image?.remote_image)
    .map(image => image.id || image.media_id || image),
  remote_images: cleanArray(form.images)
    .filter(image => image?.remote_image)
    .map(image => ({ id: image.id, url: image.url || image.image_url }))
    .filter(image => image.url),
});

export const listingIsComplete = form =>
  Boolean(
    form.canalproAccountId &&
      form.title.trim().length >= 10 &&
      form.description.trim().length >= 80 &&
      form.city.trim() &&
      form.state.trim() &&
      form.street.trim() &&
      form.zipCode.trim() &&
      positiveNumberOrNull(form.price) !== null &&
      form.images.length
  );

export const listingCanBeSavedAsDraft = form =>
  Boolean(
    form.canalproAccountId && form.title.trim() && form.description.trim()
  );
